/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Frustrating_Lack_TimeInputs */

const en_onboarding_frustrating_lack_time = /** @type {(inputs: Onboarding_Frustrating_Lack_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lack of time`)
};

const es_onboarding_frustrating_lack_time = /** @type {(inputs: Onboarding_Frustrating_Lack_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Falta de tiempo`)
};

/**
* | output |
* | --- |
* | "Lack of time" |
*
* @param {Onboarding_Frustrating_Lack_TimeInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const onboarding_frustrating_lack_time = /** @type {((inputs?: Onboarding_Frustrating_Lack_TimeInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Frustrating_Lack_TimeInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_onboarding_frustrating_lack_time(inputs)
	return en_onboarding_frustrating_lack_time(inputs)
});